import React from 'react';

const ErrorMessage = ({ message }) => {
  return (
    <div style={{
      color: '#b91c1c',
      backgroundColor: '#fee2e2',
      border: '1px solid #fca5a5',
      padding: '16px 20px',
      borderRadius: 'var(--radius-sm)',
      fontSize: '0.9rem',
      fontWeight: '600',
      margin: '16px 0',
      textAlign: 'left',
      display: 'flex',
      alignItems: 'center',
      gap: '12px'
    }}>
      <svg width="20" height="20" fill="currentColor" viewBox="0 0 16 16" style={{ flexShrink: 0 }}>
        <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
      </svg>
      <div>{message || "An error occurred while communicating with the server."}</div>
    </div>
  );
};

export default ErrorMessage;
